// extracted by mini-css-extract-plugin
export default {"card":"OptionCard_card__VfXng","gbbCard":"OptionCard_gbbCard__HIXk4","greyText":"OptionCard_greyText__ozEZA"};